export enum StepInvoiceControls {
  InvoiceNumber = 'CustomerNumber',
  InvoiceDate = 'InvoiceDate',
  InvoiceType = 'InvoiceType',
  InvoiceCheckbox = 'InvoiceCheckbox',
  DocumentUploader = 'DocumentUploader',
  ParcelPlaces = 'ParcelPlaces',
  SignatureConfirmed = 'SignatureConfirmed',
  InvoiceInformation = 'InvoiceInformation',
}
